import { Dialog } from 'primereact/dialog';
import { useTranslation } from '../../../shared/language';

export type MqrConsentIframeDialogProps = {
  visible: boolean;
  iframeUrl: string | null;
  loading?: boolean;
  onHide: () => void;
};

export const MqrConsentIframeDialog = ({
  visible,
  iframeUrl,
  loading = false,
  onHide,
}: MqrConsentIframeDialogProps) => {
  const {t} = useTranslation();
  return (
    <Dialog
      visible={visible}
      onHide={onHide}
      header={t('common.serviceTerms')}
      modal
      draggable={false}
      resizable={false}
      closable={!loading}
      dismissableMask={!loading}
      baseZIndex={4000}
      style={{ width: 'min(960px, 96vw)' }}
      contentStyle={{ padding: 0, overflow: 'hidden' }}
      className="mqr-consent-iframe-dialog"
      appendTo={typeof document !== 'undefined' ? document.body : undefined}
    >
      {iframeUrl ? (
        <iframe
          src={iframeUrl}
          title={t('common.mqrTerms')}
          className="w-full border-none border-round"
          style={{ height: 'calc(90vh - 8rem)', minHeight: '720px' }}
        />
      ) : null}
    </Dialog>
  );
};
